import { Link } from "react-router-dom"

import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'

import { Article, CardTitle, Container, Content } from "./_termsOfUse"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import api from "services/api"

export const TermsOfUse = () => {
  const [termsData, setTermsData] = useState('')

  const ensureTermsData = async () => {
    try {
      const response: any = await api.get('/system-infos')

      setTermsData(response?.data?.system_infos?.terms_and_conditions)
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    ensureTermsData()
  }, [])

  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <Link
          className="terms-content__icon-container"
          to="/perfil"
        >
          <LeftArrow
            className="terms-content__icon"
          />
        </Link>

        <CardTitle>
          <h1 className="terms-card__title">
            Termos de uso e condições
          </h1>
        </CardTitle>

        {termsData && (
          <Article>
            {termsData}
          </Article>
        )}
      </Content>
    </Container>
  )
}
